import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FfpInformationComponent } from './ffp-information.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [FfpInformationComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [FfpInformationComponent],
})
export class FfpInformationModule {}
